<script src="../../../api/set/accountageset.js"></script>
<template>
  <el-dialog title="基本信息" :visible.sync="dialogFormVisible" custom-class="max-dialog" center
             :close-on-click-modal="false" :append-to-body="true">
    <el-form :model="form" ref="form1" :rules="rules">
      <!--<el-row>-->
      <!--<el-col :span="24"><div style="background-color:#E6A23C;line-height: 40px;">111</div></el-col>-->
      <!--</el-row>-->
      <el-collapse v-model="activeNames">
        <el-collapse-item name="1">
          <template slot="title">
            <span class="titlecolor">基本信息</span>
          </template>
          <el-row :gutter="20">
            <el-col :span="11"  v-if="false">
              <el-form-item label="个人" :label-width="formLabelWidth" prop="isperson">
                <el-col :span="6">
                  <el-select v-model="form.isperson" placeholder="请选择">
                    <el-option
                      v-for="item in controlData.isperson"
                      :key="item.value"
                      :label="item.text+''"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </el-col>
              </el-form-item>
            </el-col>
            <el-col :span="7">
              <el-form-item label="名称" :label-width="formLabelWidth" prop="deptname">
                  <el-input v-model="form.deptname" auto-complete="off" :required="true" :readonly="form.audittenantid?true:false" @blur="hanlderblur"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="简称" :label-width="formLabelWidth" prop="shortname">
                <el-input v-model="form.shortname" auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="速记码" :label-width="formLabelWidth" prop="shorthandcode">
                <el-input v-model="form.shorthandcode" auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="7">
              <el-form-item label="ERP核算编号" :label-width="formLabelWidth" prop="customerserial">
                <el-input v-model="form.customerserial" auto-complete="off" placeholder="系统自动生成"
                          v-if="caneditErpSerial"></el-input>
                <span v-if="!caneditErpSerial">{{form.customerserial}}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="5">
              <el-form-item label="服务部门" :label-width="formLabelWidth" prop="servedname">
                <el-select v-model="form.servedname" placeholder="请选择" @change="change1">
                  <el-option
                    v-for="item in idd"
                    :key="item.serialnum"
                    :label="item.dname"
                    :value="item">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="7">
              <el-form-item label="上级客户" :label-width="formLabelWidth" prop="shortname">
                <el-input v-model="form.parentcustomername" auto-complete="off" clearable @clear="clearParent"
                          @click.native="showSelectCustomer"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6" v-if="categoryOptions.length > 0">
              <el-form-item label="客户分类" :label-width="formLabelWidth" prop="categoryextdept">
                <el-cascader v-model="categoryValue" :options="categoryOptions" :props="categoryProps"
                             clearable @change="onCategoryChange" style="width: 100%;"></el-cascader>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="4">
              <el-form-item label="业务员" :label-width="formLabelWidth" prop="serveuname" treeContent>
                <CommonTree ref="treeDserial" :treeHeight="180" :searchText="form.serveuname" @check="changeServer"
                            :isShowCheckBox="false"></CommonTree>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="专属客服" :label-width="formLabelWidth" prop="saleuguid" treeContent>
                <CommonTree ref="treeKefu" :treeHeight="180" :searchText="form.saleuname" @check="changeSales"
                            :isShowCheckBox="true" :defaultCheckedKeys="form.saleuguid" :canSelectGroupTypeNode="false" :onlyChildNodesCheckBox="true"></CommonTree>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="服务人员" :label-width="formLabelWidth" prop="marketuname" treeContent>
                <CommonTree ref="treeDserial" :treeHeight="180" :searchText="form.marketuname" @check="changeMarket"
                            :isShowCheckBox="false"></CommonTree>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20" v-show="isShow&&form.unitguid&&showEssilor">
            <el-col :span="8">
              <el-form-item label="" :label-width="formLabelWidth">
                <el-checkbox v-model="isShowSSO">开通订单接口</el-checkbox>
              </el-form-item>
            </el-col>
            <el-col :span="12" v-if="isShowSSO">
              <el-form-item label="供应商唯一码" :label-width="formLabelWidth">
                <!--<el-select v-model="selectSupplier" placeholder="请选择">-->
                  <!--<el-option-->
                    <!--v-for="item in supplierS"-->
                    <!--:key="item.tenantid"-->
                    <!--:label="item.tenantname"-->
                    <!--:value="item.tenantid">-->
                  <!--</el-option>-->
                <!--</el-select>-->
                <el-input v-model="selectSupplier" auto-complete="off" style="width: 200px;"></el-input>
                <span v-if="selectSupplier!='essilor'">{{isShowSSOmsg}} </span>
                <template v-if="!isShowSSOmsg&&selectSupplier&&selectSupplier.length>15&&selectSupplier!='essilor'">
                 <el-button type="success" plain size="mini" @click="registSupply" >申请开通</el-button>
                 <el-checkbox v-model="isMySystem">对接独立部署系统</el-checkbox>
                </template>
                <el-input v-model="Supplier.url" auto-complete="off" style="width: 60px;" v-if="isShowSSO&&selectSupplier=='essilor'"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20" v-show="showEssilor" v-if="isShowSSO&&selectSupplier=='essilor'">
          <el-col :span="8">
            <el-form-item label="依视路" :label-width="formLabelWidth">
              获取客户、产品、出入库接口
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="对接账号" :label-width="formLabelWidth">
              <el-input v-model="Supplier.login" auto-complete="off" style="width: 120px;"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="接口密码" :label-width="formLabelWidth">
              <el-input v-model="Supplier.password" auto-complete="off" style="width: 120px;"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
          <el-row :gutter="20" v-show="showEssilor" v-if="isShowSSO&&selectSupplier=='essilor'">
            <el-col :span="8">
              <el-form-item label="依视路" :label-width="formLabelWidth">
                销售单、采购单接口
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="对接账号" :label-width="formLabelWidth">
                <el-input v-model="Supplier.loginv2" auto-complete="off" style="width: 120px;"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="接口密码" :label-width="formLabelWidth">
                <el-input v-model="Supplier.passwordv2" auto-complete="off" style="width: 120px;"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20" v-show="showEssilor" v-if="isShowSSO&&selectSupplier=='essilor'">
            <el-col :span="8">
              <el-form-item label="clientid" :label-width="formLabelWidth">
                <el-input v-model="Supplier.clientid" auto-complete="off" ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="16">
              <el-form-item label="secret" :label-width="formLabelWidth">
                <el-input v-model="Supplier.clientsecret" auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <!--<el-row :gutter="20" v-if="false">-->
            <!--<el-col :span="8">-->
              <!--<el-form-item label="供应商免运费" :label-width="formLabelWidth" prop="freightfree" v-show="isShow">-->
                <!--<el-radio-group v-model="form.freightfree">-->
                  <!--<el-radio :label="1">是</el-radio>-->
                  <!--<el-radio :label="0">否</el-radio>-->
                <!--</el-radio-group>-->
              <!--</el-form-item>-->
            <!--</el-col>-->
          <!--</el-row>-->
          <el-row :gutter="25">
            <el-col :span="14">
              <el-form-item label="所属区域" :label-width="formLabelWidth" prop="deliveryaddress">
                <div v-if="form.audittenantid">{{form.province}}{{form.city}}{{form.county}}</div>
                <v-distpicker :province="form.province" @province="onChangeProvince" :city="form.city" v-else
                              @city="onChangeCity" :area="form.county" @area="onChangeArea" size="mini"></v-distpicker>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="授权经销区域" :label-width="formLabelWidth" prop="authzone">
                <template v-if="isShow">
                  <el-button type="text" size="mini" @click="openAuthZoneDialog">
                    <span v-if="authZoneDisplayText">{{ authZoneDisplayText }}</span>
                    <span v-else style="color: #999;">维护经销区域</span>
                  </el-button>
                </template>
                <el-input v-else v-model="form.authzone" auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="直发门店" :label-width="formLabelWidth" prop="iddirectsend" >
                <el-radio-group v-model="form.iddirectsend">
                  <el-radio :label="1">是</el-radio>
                  <el-radio :label="0">否</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="25"  v-if="isdeliverShow">
            <el-col :span="6" v-show="caneditContractprice">
              <el-form-item label="价格等级" :label-width="formLabelWidth" prop="pricelevel">
                <el-select v-model="form.pricelevel" placeholder="请选择">
                  <el-option key="99999" label="按品牌设置(组合)" value="99999">
                  </el-option>
                  <el-option
                    v-for="item in parameterData"
                    :key="item.value"
                    :label="item.name"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item label="" :label-width="formLabelWidth" prop="unitgroup">
                <el-checkbox-group v-model="unitgroup">
                  <el-checkbox v-for="item in controlData.unitgroup" v-show="item.value=='4'"
                               :key="item.value+''"
                               :label="item.value+''"
                               v-on:click="toggle()">{{item.text}}
                  </el-checkbox>
                </el-checkbox-group>
              </el-form-item>
            </el-col>
            <el-col :span="7" v-show="caneditContractprice">
              <el-form-item label=" " :label-width="formLabelWidth" prop="settingmenthod">
                <div style="display: flex; align-items: baseline; flex-wrap: wrap;">
                  <el-checkbox-group v-model="settingmenthod">
                    <el-checkbox v-for="item in controlData.settingmenthod"
                                 :key="item.value+''"
                                 :label="item.value+''">{{item.text}}
                    </el-checkbox>
                  </el-checkbox-group>
                  <el-checkbox v-model="form.rijie" true-label="1" false-label="0" @change="onRijieChange" style="margin-left: 10px;">日结</el-checkbox>
                </div>
                <div style="cursor: pointer;color: blue" @click="setBasisGoods" >设置月结商品(选 现金+月结 时生效)</div>
              </el-form-item>
            </el-col>
            <el-col :span="8" v-show="caneditContractprice">
            <el-col :span="12">
              <el-form-item label="账期" :label-width="formLabelWidth2" prop="closeaccountsdate">
                <el-input v-model="form.closeaccountsdate" auto-complete="off" style="width: 120px"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="帐龄" :label-width="formLabelWidth2" prop="happendate">
                <div style="cursor: pointer;color: blue" @click="setHappendate" v-if="isShow">设置</div>
                <el-input v-model="form.happendate" auto-complete="off" v-else style="width: 120px"></el-input>
              </el-form-item>
            </el-col>
              <el-col :span="24">
                <el-form-item label="信用额度" :label-width="formLabelWidth2" prop="linecredit">
                  <el-input v-model="form.linecredit" auto-complete="off" style="width: 120px"></el-input>
                  <el-checkbox  v-model="overlinecredit">超额度允许开单</el-checkbox>
                </el-form-item>
              </el-col>
              <el-col :span="12" v-if="false">
              <el-form-item label="" :label-width="formLabelWidth" prop="settingmoney">
                <el-input v-model="form.settingmoney" auto-complete="off"></el-input>
              </el-form-item>
              </el-col>
            </el-col>
          </el-row>
          <el-row :gutter="25"  v-if="isShow">
              <el-col :span="8" >
                <el-form-item label="帐龄" :label-width="formLabelWidth" prop="happendate">
                  <div style="cursor: pointer;color: blue" @click="setHappendate">设置</div>
                </el-form-item>
              </el-col>
          </el-row>
          <el-row :gutter="25" v-show="caneditContractprice" v-if="form.pricelevel=='99999'">
            <el-col :span="20">
              <el-form-item label="" :label-width="formLabelWidth">
                <AccountAgeEdit ref="AccountPrice" :customerserial="form.customerserial" :parameterData="parameterData"
                                :showPriceSet="true"></AccountAgeEdit>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="25">
            <el-col :span="12">
              <el-form-item label="标签" :label-width="formLabelWidth" prop="descri">
                <el-tag :key="tag" v-for="tag in ticket"  closable :disable-transitions="false" @close="taghandleClose(tag)">{{tag}}</el-tag>
                <el-input class="input-new-tag" v-model="taginputValue" style="width: 120px" v-if="taginputVisible" ref="saveTagInput" size="small"
                  @keyup.enter.native="taghandleInputConfirm" @blur="taghandleInputConfirm" auto-complete="on">
                </el-input><el-button v-else class="button-new-tag" size="small"  @click="tagshowInput">加标签</el-button>

                <el-tag :key="tag" v-for="tag in ticketprint"  closable :disable-transitions="false" @close="taghandleClosePrint(tag)">{{tag}}</el-tag>
                <el-input class="input-new-tag" v-model="taginputValuePrint" style="width: 120px" v-if="taginputVisiblePrint" ref="saveTagInputPrint" size="small"
                          @keyup.enter.native="taghandleInputConfirmPrint" @blur="taghandleInputConfirmPrint" auto-complete="on">
                </el-input><el-button v-else class="button-new-tag" size="small"  @click="tagshowInputPrint">加打印标签</el-button>
                <el-button type="primary" @click="saveTicket" v-if="!CanEdit&&form.unitguid" size="mini">保存</el-button>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="备注" :label-width="formLabelWidth" prop="descri">
                <el-input v-model="form.descri" auto-complete="off"  type="textarea"  :rows="1"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="25">
            <el-col :span="12">
              <el-form-item label="附件" :label-width="formLabelWidth" prop="attguid">
                <CommonUpload ref="refattguid" :multiple="true" :groupGuid="form.attguid" :disabled="!CanEdit" groupType="externaldept" :limit="10"></CommonUpload>
              </el-form-item>
            </el-col>
          </el-row>
        </el-collapse-item>
        <el-collapse-item name="7" v-show="caneditContractprice" v-if="isdeliverShow&&form.unitguid&&form.pricelevel&&form.pricelevel!='99999'">
          <template slot="title" style="width: 1160px;display: inline-block;">
            <span class="titlecolor">特殊折扣设置（如 定制片单独打折、77折88折等不常用折扣）
            <el-button size="small" type="text" v-on:click.stop="addCatgroyDisCount"
                       style="margin-right: 50px;float: right" v-if="CanEdit">新增</el-button>
            </span>
          </template>
          <el-row :gutter="20">
            <SaleFavourList ref="SaleFavourList" :searchcustomerserial="form.customerserial" :forExternalDept="true"
                            :CanEdit="CanEdit"></SaleFavourList>
          </el-row>
        </el-collapse-item>
        <el-collapse-item name="2" v-show="caneditContractprice" v-if="isdeliverShow&&form.unitguid">
          <template slot="title" style="width: 1160px;display: inline-block;">
            <span class="titlecolor">促销协议
            <el-button size="small" type="text" v-on:click.stop="addSaleContract"
                       style="margin-right: 50px;float: right" v-if="CanEdit">新增</el-button>
            </span>
          </template>
          <el-row :gutter="20">
            <SaleContractList ref="SaleContractList" :showlist="false" :searchcustomerserial="form.customerserial"
                              :searchcustomername="form.deptname" :canEdit="CanEdit"></SaleContractList>
          </el-row>
        </el-collapse-item>
        <el-collapse-item name="3">
          <template slot="title" style="width: 1160px;display: inline-block;">
            <span class="titlecolor">联系人
            <el-button size="small" type="text" v-on:click.stop="addContactor"
                       style="margin-right: 50px;float: right" v-if="CanEdit">新增</el-button>
            </span>
          </template>
          <el-row :gutter="20">
            <table cellspacing="0" cellpadding="0" border="0" style="border-collapse:collapse;width:100%;"
                   class="query-table">
              <tr>
                <td style="background-color: #F4F4F4;text-align: center;" class="center">姓名</td>
                <td style="background-color: #F4F4F4;  text-align: center;" class="center">手机号</td>
                <td style="background-color: #F4F4F4;  text-align: center;" class="center">职务</td>
                <td style="width: 100px;background-color: #F4F4F4;  text-align: center;" class="center">操作</td>
              </tr>
              <tr v-for="(item,index) in acontactor">
                <td class="content" :class="{mainlink:item.mobile==form.linkmantel}">
                  {{item.uname}}
                </td>
                <td class="content" :class="{mainlink:item.mobile==form.linkmantel}">
                  {{item.mobile}}
                </td>
                <td class="content" :class="{mainlink:item.mobile==form.linkmantel}">
                  {{item.title}}
                </td>
                <td class="content">
                  <el-button @click="handleExernaldeptContactorEdit(index,item)" type="text" size="small"
                             v-if="CanEdit">
                    编辑
                  </el-button>
                  <el-button @click="handleExernaldeptContactorDelete(index,item)" type="text"
                             size="small" v-if="CanEdit">删除
                  </el-button>
                </td>
              </tr>
            </table>
          </el-row>
        </el-collapse-item>
        <el-collapse-item name="4">
          <template slot="title" style="width: 1160px;display: inline-block;">
             <span class="titlecolor">收货地址
              <el-button size="small" type="text" v-on:click.stop="addAddress"
                         style="margin-right: 50px;float: right" v-if="CanEdit">新增</el-button>
             </span>
          </template>
          <AddressEdit ref="AddressData" @addresss="addresss" :unitguid="form.uguid"></AddressEdit>
          <el-row :gutter="20">
            <table cellspacing="0" cellpadding="0" border="0" style="border-collapse:collapse;width:100%;"
                   class="query-table">
              <tr>
                <td style="background-color: #F4F4F4;  text-align: center;" class="center">地址</td>
                <td style="background-color: #F4F4F4;  text-align: center;" class="center">联系方式</td>
                <td style="width:80px;background-color: #F4F4F4;  text-align: center;" class="center">排序</td>
                <td style="width:100px;background-color: #F4F4F4;  text-align: center;" class="center">操作</td>
              </tr>
              <tr v-for="(item,index) in this.aform">
                <td class="content">
                  {{item.province}} {{item.city}} {{item.county}} {{item.address}}
                  <el-tag v-if="item.defalut == '1' || item.defalut == 1" size="mini" type="danger" style="margin-left:6px;">默认</el-tag>
                </td>
                <td class="content">
                  {{item.uname}} {{item.mobile}}
                </td>
                <td class="content">
                  {{item.sort != null && item.sort != '' ? item.sort : 0}}
                </td>
                <td class="content">
                  <el-button @click="editaddress(index,item)" type="text" size="small" v-if="CanEdit">
                    编辑
                  </el-button>
                  <el-button @click="deleteaddress(index, item)" type="text" v-if="CanEdit"
                             size="small">删除
                  </el-button>
                </td>
              </tr>
            </table>
          </el-row>
        </el-collapse-item>
        <el-collapse-item name="5" v-if="false&isdeliverShow&&form.unitguid">
          <template slot="title">
            <span class="titlecolor">设置账期</span>
          </template>
          <el-row :gutter="20" style="padding-left: 40px;padding-right: 40px">
            <AccountAgeEdit ref="AccountAgeEdit" :customerserial="form.customerserial"
                            :parameterData="controlData.settingmenthod" :showPriceSet="false"></AccountAgeEdit>
          </el-row>
        </el-collapse-item>
        <el-collapse-item name="6">
          <template slot="title">
            <span class="titlecolor">开票相关</span>
          </template>
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="开户行" :label-width="formLabelWidth" prop="bank">
                <el-input v-model="form.bank" auto-complete="off" :required="true"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="账号" :label-width="formLabelWidth" prop="bankaccount">
                <el-input v-model="form.bankaccount" auto-complete="off" :required="true"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="顺丰月结卡" :label-width="formLabelWidth" prop="bankname">
                <el-input v-model="form.bankname" auto-complete="off" :required="true"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6" v-if="merchantnoOptions.length > 1">
              <el-form-item label="收款商户号" :label-width="formLabelWidth" prop="merchantno">
                <el-select v-model="form.merchantno" placeholder="请选择" clearable>
                  <el-option
                    v-for="item in merchantnoOptions"
                    :key="item.merchantno"
                    :label="item.orgname"
                    :value="item.merchantno">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="开票地址" :label-width="formLabelWidth" prop="address">
                <el-input v-model="form.address" auto-complete="off" :required="true"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="开票电话" :label-width="formLabelWidth" prop="companytel">
                <el-input v-model="form.companytel" auto-complete="off" :required="true"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="纳税人识别号" :label-width="formLabelWidth" prop="taxplayerid">
                <el-input v-model="form.taxplayerid" auto-complete="off" :required="true"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

        </el-collapse-item>
      </el-collapse>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">关 闭</el-button>
      <el-button type="primary" @click="saveData" v-if="CanEdit">确 定</el-button>
      <div style="float: right;padding-right: 50px;cursor: pointer" @click="supplydrawer=true" v-if="editlogtable&&editlogtable.length>0">最近修改：{{editlogtable[0].uname}} {{editlogtable[0].adddate}}</div>
    </div>
    <SettingMenthodEdit ref="SettingMenthodEdit1" @AfterBasis="AfterBasis"></SettingMenthodEdit>
    <AgeEdit ref="AgeEdit" @AfterAgeEdit="AfterAgeEdit"></AgeEdit>
    <ExternaldeptcontactorEdit ref="DataContactorEdit"  @AfterEditContactor="AfterEditContactor"></ExternaldeptcontactorEdit>
    <ExternaldeptSel ref="externaldeptsel" @select="afterSelExternalDept"></ExternaldeptSel>
    <ExternaldeptSel ref="authzoneCustSel" @select="onTempCustomerSelect"></ExternaldeptSel>
    <el-drawer v-if="editlogtable.length>0" :withHeader="false" :modal="false" title="修改日志" :visible.sync="supplydrawer" :wrapperClosable="true" :append-to-body="true" :direction="'rtl'">
      <el-table :data="editlogtable" size="mini"  :height="tableHeight(-60)" stripe border style="width: 100%;">
        <el-table-column
          label="时间" prop="adddate"
          align="left" width="180px"
          header-align="center">
        </el-table-column>
        <el-table-column
          label="姓名" prop="uname"
          align="left"
          header-align="center" >
        </el-table-column>
      </el-table>
    </el-drawer>
    <el-dialog title="授权经销区域" :visible.sync="authZoneDialogVisible" width="750px" :append-to-body="true">
      <div>
        <div style="margin-bottom: 15px; display: flex; align-items: center; flex-wrap: wrap; gap: 6px;">
          <el-button size="mini" @click="showCustomerForAuthZone">
            {{ tempCustomerName ? tempCustomerName : '选择客户(可选)' }}
          </el-button>
          <el-button size="mini" type="danger" plain v-if="tempCustomerName" @click="clearTempCustomer">×</el-button>
          <v-distpicker :province="tempProvince" @province="onTempProvinceChange" :city="tempCity"
                        @city="onTempCityChange" hide-area size="mini"></v-distpicker>
          <el-button type="primary" size="mini" @click="addAuthZoneItem">添加</el-button>
        </div>
        <el-input size="mini" style="width: 220px; margin-bottom: 10px;"
                  placeholder="搜索区域/客户" prefix-icon="el-icon-search" v-model="authZoneSearch"></el-input>
        <el-table :data="filteredAuthZoneItems" border size="mini" style="width: 100%;" max-height="300">
          <el-table-column prop="customername" label="客户" min-width="120" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.customername || '(全部客户)' }}</span>
            </template>
          </el-table-column>
          <el-table-column label="省" min-width="120" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.customerserial ? '(全部区域)' : scope.row.province }}</span>
            </template>
          </el-table-column>
          <el-table-column label="市" min-width="120" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.customerserial ? '' : (scope.row.city || '(全部)') }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="80" align="center">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="deleteAuthZoneItem(scope.$index)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="authZoneDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="saveAuthZoneDialog">确定</el-button>
      </div>
    </el-dialog>
  </el-dialog>
</template>

<script>
  import ExternaldeptSel from '@/components/set/externaldept/ExternaldeptSel'
  import ExternaldeptcontactorEdit from './ExternaldeptcontactorEdit';
  import AddressEdit from './AddressEdit';
  import {saveData,updateSimple, getDetail, getControlData, getListData, getContactorDetail, yeepayMerchantnolist} from '@/api/set/externaldept';
  import {regist, registCheck, registDraw, listSupplier} from '@/api/ossi';
  import {getParameterDetail} from '@/api/set/parameter';
  import {independentDept} from '@/api/set/dept';
  import {checkCustomerserial} from '@/api/set/accountageset';
  import {attUUID} from '@/api/attachment';
  import AccountAgeEdit from './AccountAgeEdit';
  import AgeEdit from './AgeEdit'
  import SaleContractList from '@/components/testorder/salecontract/SaleContractList';
  import SaleFavourList from '@/components/set/salefavour/SaleFavourList';
  import SettingMenthodEdit from './SettingMenthodEdit';
  import {saveData as saveHandlelog, getListData as getHandlelist} from '@/api/set/handlelog';

  export default {
    name: "ExternaldeptEdit",
    data() {
      return {
        inaudit: false,
        showEssilor:false,
        caneditErpSerial: false,
        useDisabled: true,
        CanEdit: true,
        oladformdata:'',
        editlogtable:[],
        supplydrawer:false,
        dialogFormVisible: false,
        activeNames: ['1', '2', '3', '4', '5', '6', '7'],
        unitgroup: [],
        settingmenthod: [],
        caneditContractprice:true,
        userInfoModel:{},
        isShow: false,
        isShowSSO:false,
        isMySystem:false,
        isShowSSOmsg:"",
        supplierS:[],
        selectSupplier:'',
        Supplier:{
          supplier:'',
          login:'',
          password:'',
          loginv2:'',
          passwordv2:'',
          clientid:'',
          clientsecret:'',
          url:''
        },
        isdeliverShow: false,
        aform: [],
        acontactor: [],
        idd: [],
        serverAlertTitle: '',
        overlinecredit:false,
        isClickEvent: true,//选择供应商、客户清空图标按钮不触发click事件使用
        form: {  //表单数据
          unitguid: '',
          isperson: 0,
          deptname: '',
          shortname: '',
          shorthandcode: '',
          customerserial: '',
          linkman: '',
          linkmantel: '',
          unitgroup: '',
          pricelevel: '',
          settingmoney: '',
          settingmenthod: '',
          servedname: '',
          serveuguid: '',
          marketuguid:'',
          marketuname:'',
          servedserial: '',
          serveuname: '',
          saleuname: '',
          saleuguid: '',
          authzone: '',
          audittenantid: '',
          iddirectsend: 0,
          freightfree: 0,
          deliveryaddress: '',
          descri: '',
          ticket: '',
          bank: '',
          bankname: '',
          bankaccount: '',
          address: '',
          companytel: '',
          taxplayerid: '',
          industrycode: '',
          contactor: '',
          attguid: '',
          happendate: '',
          linecredit: '',
          monthlybasis: '',
          parentcustomername: '',//上级客户名称
          parentcustomerserial: '',//上级客户编号
          closeaccountsdate: "",//结账日期
          rijie: '0',//日结（1是 0否）
          usesso: '',
          ssocode: '',
          aging: '',
          uname: '',
          adddate: '',
          merchantno: '',
          categoryextdept: '',
        },
        categoryOptions: [],
        categoryProps: {
          value: 'code',
          label: 'name',
          children: 'children',
          emitPath: false
        },
        categoryValue: [],
        authZoneDialogVisible: false,
        authZoneItems: [],
        authZoneSearch: '',
        tempProvince: '',
        tempCity: '',
        tempCustomerSerial: '',
        tempCustomerName: '',
        controlData: {//绑定的控件数据，例如下拉框、复选框，单选按钮组等。
          isperson: [],
          settingmenthod: [],
          unitgroup: []
        },
        merchantnoOptions: [],
        parameterData: [],
        formLabelWidth: '120px',
        formLabelWidth2: '70px',
        ticket:[],
        ticketprint:[],
        taginputVisible: false,
        taginputValue : '',
        taginputVisiblePrint: false,
        taginputValuePrint : '',
        rules: {////////定义正则验证字段。
        deptname: [
          {required: true, message: '请输入姓名', trigger: 'blur'},
        ],
          unitgroup: [
            {required: true, message: '请选择分类', trigger: 'blur'},
          ],
          isperson: [
            {required: true, message: '请选择', trigger: 'blur'},
          ],
          pricelevel: [
            {required: true, message: '请选择', trigger: 'blur'},
          ],
          servedname: [
            {required: true, message: '请选择', trigger: 'blur'},
          ]
        },
      }
    },
    computed: {
      authZoneDisplayText() {
        if (!this.form || !this.form.authzone) return '';
        try {
          var items = JSON.parse(this.form.authzone);
          if (!Array.isArray(items) || items.length === 0) return '';
          return items.map(function(item) {
            if (item.customerserial) {
              return '[' + (item.customername || item.customerserial) + ']';
            }
            return item.city ? item.province + '-' + item.city : item.province;
          }).join('、');
        } catch (e) {
          return this.form.authzone;
        }
      },
      filteredAuthZoneItems() {
        var search = this.authZoneSearch ? this.authZoneSearch.toLowerCase() : '';
        if (!search) return this.authZoneItems;
        return this.authZoneItems.filter(function(item) {
          return (item.province && item.province.toLowerCase().indexOf(search) > -1) ||
                 (item.city && item.city.toLowerCase().indexOf(search) > -1) ||
                 (item.customername && item.customername.toLowerCase().indexOf(search) > -1) ||
                 (item.customerserial && item.customerserial.toLowerCase().indexOf(search) > -1);
        });
      }
    },
    methods: {
      onRijieChange(val) {
        if (val === '1') {
          // 勾选日结，确保200被选中，但保留其他已选结算方式
          if (this.settingmenthod.indexOf('200') === -1) {
            this.settingmenthod.push('200');
          }
        }
      },
      //清空上级客户
      clearParent() {
        this.isClickEvent = false
        this.form.parentcustomername = ""
        this.form.parentcustomerserial = ""
      },
      onCategoryChange(value) {
        this.form.categoryextdept = value || '';
      },
      loadCategoryOptions() {
        const {getParameterDetail} = require('@/api/set/parameter');
        getParameterDetail({paraname: "客户分类"}).then(response => {
          if (response.data && response.data.obj && response.data.obj.paracontent) {
            this.categoryOptions = JSON.parse(response.data.obj.paracontent);
          } else {
            this.categoryOptions = [];
          }
        }).catch(() => {
          this.categoryOptions = [];
        });
      },
      //查询条件的选择供应商或者门店之后执行
      afterSelExternalDept(customerserial, customername, row) {
        this.form.parentcustomername = customername
        this.form.parentcustomerserial = customerserial
      },
      showSelectCustomer() {
        if (this.isClickEvent) {
          this.$refs.externaldeptsel.show(1, '选择客户')
        } else {
          this.isClickEvent = true
        }
      },
      addSaleContract() {
        this.$refs.SaleContractList.add();
      },
      addCatgroyDisCount() {
        this.$refs.SaleFavourList.add(this.form.customerserial, this.form.customername);
      },
      change1(val) {
        this.form.servedserial = val.serialnum;
        this.form.servedname = val.dname;
      },
      changeServer(guids, names, arr) {
        this.form.serveuguid = guids;
        this.form.serveuname = names;
      },
      changeMarket(guids, names, arr) {
        this.form.marketuguid = guids;
        this.form.marketuname = names;
      },
      changeSales(guids, names, arr){
        this.form.saleuguid = guids;
        this.form.saleuname = names;
      },
      onChangeProvince(data) {
        if (data.value == '省') data.value = '';
        this.form.province = data.value;
      }, onChangeCity(data) {
        if (data.value == '市') data.value = '';
        this.form.city = data.value;
      }, onChangeArea(data) {
        if (data.value == '区' || data.value == '县') data.value = '';
        console.log('触发了')
        console.log(this.form.county)
        this.form.county = data.value;
      }, toggle() {
        this.isShow = !this.isShow;
      }, settingmenthodToggle() {
        this.settingmenthodShow = !this.settingmenthodShow;
      }, hanlderblur(event) {
      },
      initstoredata(row) {
        this.form.deptname = row.dname
        this.form.province = row.province
        this.form.city = row.city
        this.form.county = row.county
        this.settingmenthod = ['200'];
        if (this.idd.length > 0)
          this.change1(this.idd[0]);
        this.aform = [{
          unitguid: attUUID(),
          area: '',
          address: row.address.replace(row.province, '').replace(row.city, '').replace(row.county, ''),
          uname: row.dname,
          defalut: '1',
          mobile: row.tel,
          province: row.province,
          city: row.city,
          county: row.county,
        }];
      },
      initcusserial(row){
        this.inaudit = true;
        this.form.deptname=row.deptname;
        this.form.customerserial=row.customerserial;
        this.settingmenthod = ['200'];
      },
      show(unitgroup) {
        this.unitgroup = unitgroup;
        this.taginputVisible = false;
        this.taginputValue = '';
        this.taginputVisiblePrint = false;
        this.taginputValuePrint = '';
        this.form.ticket='';
        this.ticket=[];
        this.ticketprint=[];
        this.caneditErpSerial = true;
        this.form.unitguid = null
        this.dialogFormVisible = true
        this.form.deliveryaddress = null
        this.form.monthlybasis=''
        this.form.province = null
        this.form.city = null
        this.form.county = null
        this.form.deptname = null
        this.loadCategoryOptions();
        this.form.shortname = null
        this.form.shorthandcode=null
        this.form.contactor = null
        this.form.usesso = ''
        this.form.ssocode = ''
        this.form.authzone=''
        this.form.audittenantid=''
        this.Supplier.supplier=''
        this.Supplier.password = ''
        this.Supplier.login = ''
        this.Supplier.loginv2 = ''
        this.Supplier.clientid = ''
        this.Supplier.clientsecret = ''
        this.Supplier.url = ''
        this.selectSupplier = ''
        this.acontactor = [];
        this.isShowSSO=false;
        this.isMySystem=false
        this.overlinecredit=false;
        this.caneditContractprice=true;
        getParameterDetail({paraname: "客户价格等级"}).then(response => {
          this.parameterData = JSON.parse(response.data.obj.paracontent);
        })
        if(this.idd.length==1)
          this.change1(this.idd[0]);
        this.loadMerchantnoOptions();
      },
      loadMerchantnoOptions() {
        yeepayMerchantnolist().then(response => {
          if (response.data.code == 0) {
            var list = JSON.parse(response.data.list);
            this.merchantnoOptions = list || [];
          }
        });
      },
      closePage(){
        this.dialogFormVisible = false;
      },
      saveTicket() {
        this.form.ticket = this.ticket.join(';') + '$' + this.ticketprint.join(';');
        updateSimple({unitguid: this.form.unitguid, ticket: this.form.ticket}).then(response => {
          if (response.data.code == 0) {
            this.$message({
              message: '保存成功',
              type: 'success'
            })
            this.$emit('AfterSave');
          }
        });
      },
      saveData() {
        if (this.aform) {
          this.form.deliveryaddress = JSON.stringify(this.aform);
        }
        this.form.contactor = JSON.stringify(this.acontactor);
        this.$refs.form1.validate((valid) => {
          if (valid) {
            this.form.settingmenthod = this.settingmenthod.join(',');
            this.form.settingmoney = this.overlinecredit ? 99 : 0;

            // 日结时必须勾选月结(200)
            if (this.form.rijie == '1' && this.settingmenthod.indexOf('200') === -1) {
              this.$message({message: '请勾选月结后再保存！', type: 'warning'});
              return;
            }

            if (this.$refs.AccountAgeEdit && !this.$refs.AccountAgeEdit.checkData('账期必填！'))//检查不通过
              return;
            if (this.$refs.AccountPrice && !this.$refs.AccountPrice.checkData('价格等级必选！'))//检查不通过
              return;
            this.form.usesso = this.isShowSSO ? (this.isMySystem ? '2' : '1') : '';
            if (!this.isShowSSO && !this.form.ssocode) {
              registDraw({idencode: this.form.ssocode}, this.isMySystem).then(response => {
              });//撤销接口
              this.form.ssocode = '';
            }
            this.form.ticket = this.ticket.join(';')+'$'+this.ticketprint.join(';');

            if (this.form.unitguid) {
              if (this.form.linecredit == '') this.form.linecredit = -99;
              if (this.form.closeaccountsdate == '') this.form.closeaccountsdate = -99;
              if (this.form.happendate == '') this.form.happendate = -99;
            }

            saveData(this.form).then(response => {
              if (response.data.code == 0) {
                //保存账期
                if (this.$refs.AccountAgeEdit)
                  this.$refs.AccountAgeEdit.saveData(response.data.serial);
                if (this.$refs.AccountPrice)
                  this.$refs.AccountPrice.saveData(response.data.serial);

                if (this.isShowSSO && this.form.unitguid && this.selectSupplier == 'essilor') {//依视路 接口对接
                  this.Supplier.supplier = this.selectSupplier;
                  updateSimple({
                    unitguid: this.form.unitguid,
                    usesso: '1',
                    ssocode: JSON.stringify(this.Supplier)
                  }).then(response => {
                  });
                }
                this.handlelog();
                this.$message({
                  message: '保存成功',
                  type: 'success'
                })
                if (this.form.unitguid || this.inaudit)
                  this.dialogFormVisible = false;
                else {
                  this.form.customerserial = response.data.serial;
                  this.initData(response.data.unitguid, true);
                }
                //刷新列表
                this.$emit('AfterSave', this.form, response.data.unitguid);
              } else {
                this.$message({message: response.data.msg, type: 'error'});
              }
            });
          }
        })
      },
      AfterEditContactor(index, item) {//联系人编辑完成
        if (item.mainlink == 1 || this.form.linkmantel == '') {
          this.form.linkmantel = item.mobile;
          this.form.linkman = item.uname;
        }

        var NewItem = {};
        for (var p in item) {//遍历json对象的每个key/value对,p为key
          NewItem[p] = item[p];
        }
        if (index == -1) {//追加一条
          this.acontactor.splice(this.acontactor.length, 1, NewItem);
        } else {
          this.acontactor.splice(index, 1, NewItem);
        }
      },
      addContactor() {
        this.$refs.DataContactorEdit.initFormContactor()
        this.OpenContactorDialog()
      },
      OpenContactorDialog() {
        this.$refs.DataContactorEdit.showContactor(this.form.unitguid, this.acontactor);
      },
      handleExernaldeptContactorEdit(index, item) {
        item.mainlink = item.mobile == this.form.linkmantel ? 1 : 0;
        this.OpenContactorDialog();
        this.$refs.DataContactorEdit.initContactorData(index, item);
      },
      handleExernaldeptContactorDelete(index, item) {
        this.$confirm('是否确定删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.acontactor.splice(index, 1)
        }).catch(() => {
        });
      },
      ShowAudit(RowData, CanEdit) {
        this.inaudit = true;
        this.show(['1']);
        this.initRowData(RowData);
        this.CanEdit = CanEdit;
      },
      ShowSupply() {
        this.isShowSSO = this.form.usesso == '1'||this.form.usesso == '2';
        this.isMySystem=this.form.usesso == '2';
        this.isShowSSOmsg = ''
        this.selectSupplier=''
        if (this.isShowSSO && this.form.ssocode) {
          if (this.form.ssocode.indexOf("supplier")>-1) {//其他业务系统接口对接
            var sc=JSON.parse(this.form.ssocode);
            this.Supplier=sc;
            this.selectSupplier=sc.supplier;
          }else if(this.form.ssocode.indexOf("INTER$")>-1){//找眼镜自己的接口 不用处理
            this.isShowSSOmsg =  '已开通';
            this.selectSupplier = this.form.ssocode;
          } else {
            registCheck({
              fromserial: this.form.customerserial,
              fromtenantid: this.userInfoModel.tenantid,
              idencode: this.form.ssocode
            },this.isMySystem).then(response => {
              if (response.data.code == 0) {
                this.isShowSSOmsg = response.data.obj.toserial ? '已开通' : '等待授权';
                this.selectSupplier = response.data.obj.totenantid;
              } else {
                this.form.ssocode = ''
              }
            });
          }
        }
      },
      registSupply() {
        if (this.isShowSSO) {
          this.$confirm('是否确定开通?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            regist({
              title:this.form.deptname,
              fromserial: this.form.customerserial,
              fromtenantid: this.userInfoModel.tenantid,
              totenantid: this.selectSupplier,
              cusname:this.userInfoModel.tenantname
            },this.isMySystem).then(response => {
              if (response.data.code == 0) {
                this.isShowSSOmsg = '等待授权';
                this.form.ssocode = response.data.obj.idencode;
                updateSimple({
                  unitguid: this.form.unitguid,
                  usesso: (this.isShowSSO ? (this.isMySystem ? '2' : '1') : ''),
                  ssocode: this.form.ssocode
                }).then(response => {
                });
              } else {
                this.$message({
                  message: response.data.msg,
                  type: 'error'
                })
              }
            });
          }).catch(() => {
          });

        }
      },
      initData(unitguid, canEdit) {
        this.CanEdit = canEdit;
        this.form.unitguid = unitguid;
        this.caneditContractprice=false
        getDetail({unitguid: unitguid}).then(response => {
          checkCustomerserial({customerserial:response.data.obj.customerserial}).then(resContract=>{
            this.caneditContractprice =!resContract.data.code==0;
          })
          this.caneditErpSerial = false;
          this.initRowData(response.data.obj);
          this.loadMerchantnoOptions();
        });
      },
      initRowData(formdata) {
        this.oladformdata=JSON.stringify(formdata);
        for (let i in this.form) {
          this.form[i] = formdata[i]
        }
        this.overlinecredit=this.form.settingmoney==99;
        this.ticket=[];
        this.ticketprint=[];
        if(this.form.ticket) {
          var ticketbefore = this.form.ticket.split('$')[0]
          this.ticket = ticketbefore ? ticketbefore.split(';') : [];
          if (this.form.ticket.indexOf('$') > -1) {
            ticketbefore = this.form.ticket.split('$')[1]
            this.ticketprint = ticketbefore ? ticketbefore.split(';') : [];
          }
        }
        if (!this.form.deliveryaddress || this.form.deliveryaddress == '') {
          this.aform = [];
        } else {
          this.aform = JSON.parse(this.form.deliveryaddress);
        }
        this.sortAform();
        this.ShowSupply();
        this.acontactor = JSON.parse(this.form.contactor);
        if (!this.form.attguid || this.form.attguid == '') {
          this.form.attguid = attUUID();
        }
        getParameterDetail({paraname: "客户价格等级"}).then(response => {
          this.parameterData = JSON.parse(response.data.obj.paracontent);
          this.form.pricelevel = formdata.pricelevel;
        })
        this.unitgroup = this.form.unitgroup.split(',')
        this.settingmenthod = this.form.settingmenthod.split(',')
        // 设置分类级联值
        this.categoryValue = this.form.categoryextdept || [];
        // 如果勾选了日结，确保200被选中（而不是只选中200）
        if (this.form.rijie == '1' && this.settingmenthod.indexOf('200') === -1) {
          this.settingmenthod.push('200');
        }
        //   //获取关联的供应商
        //   getContactorDetail({unitguid: this.form.contactorguid}).then(response => {
        //     this.serverAlertTitle = response.data.obj.uname + ' ' + response.data.dept.deptname;
        //   });
        // }
        var cusSerial = this.form.customerserial
        if (cusSerial) {
          if (this.$refs.AccountAgeEdit)
            this.$refs.AccountAgeEdit.initData(cusSerial);
          if (this.$refs.AccountPrice)
            this.$refs.AccountPrice.initData(cusSerial);
          if (this.$refs.SaleContractList)
            this.$refs.SaleContractList.bindGrid(cusSerial);
          if (this.$refs.SaleFavourList)
            this.$refs.SaleFavourList.bindGrid(cusSerial);
        }
        this.showlog();
      },
      editaddress(index, row) {
        this.$refs.AddressData.showaddress(row);
      },
      addresss(ad) {
        var flag = true;
        if (ad.unitguid) {
          //若果有对象就替换
          for (var i = 0; i < this.aform.length; i++) {
            if (this.aform[i].unitguid == ad.unitguid) {
              this.aform.splice(i, 1, ad)
              flag = false;
            } else if (ad.defalut == 1 || ad.defalut == '1') {
              this.aform[i].defalut = 0;
            }
          }
          if (flag) {
            this.aform.push(ad)
          }
          this.sortAform();
        }
      },
      //收货地址排序：默认地址最前，其余按 sort 降序（大的在前）
      sortAform() {
        this.aform.sort(function (a, b) {
          var ad = (a.defalut == '1' || a.defalut == 1) ? 1 : 0;
          var bd = (b.defalut == '1' || b.defalut == 1) ? 1 : 0;
          if (ad != bd) return bd - ad;
          var asort = a.sort != null && a.sort != '' ? parseInt(a.sort) : 0;
          var bsort = b.sort != null && b.sort != '' ? parseInt(b.sort) : 0;
          if (asort != bsort) return bsort - asort;
          return 0;
        });
      },
      //处理日志
      handlelog() {
        var handlelog = {}
        handlelog.erpserial = this.form.unitguid
        if (!handlelog.erpserial) return;
        handlelog.isopen = 0
        handlelog.insub = 0;
        handlelog.casestepname = '修改单位';
        handlelog.remark = this.oladformdata;
        saveHandlelog(handlelog).then(response => {});
      },
      showlog() {
        this.editlogtable=[];
        if (!this.form.unitguid) return;
        getHandlelist({erpserial: this.form.unitguid}).then(reponse => {
          this.editlogtable = reponse.data.obj;
          this.editlogtable.push({uname:this.form.uname,casestepname:'增加',remark:'',adddate:this.form.adddate});
        })
      },
      initForm() {
        if (this.$refs.form1 !== undefined) {
          this.$refs.form1.resetFields();
        }
        this.isShowSSO=false
        this.isMySystem=false
        this.supplydrawer=false
        this.isClickEvent = true
        this.oladformdata='';
        this.acontactor = [];
        this.settingmenthod = [];
        this.editlogtable=[];
        this.aform = [];
        this.form.rijie = '0';
        this.form.linkman = '';
        this.form.linkmantel = '';
        this.form.saleuguid = '';
        this.form.saleuname = '';
        this.form.serveuguid = '';
        this.form.serveuname = '';
        this.form.marketuguid = '';
        this.form.marketuname = '';
        this.form.parentcustomername = ""
        this.form.parentcustomerserial = ""
        this.form.aging=""
        this.form.authzone=""
        this.form.audittenantid=""
        this.form.merchantno=""
        this.form.settingmoney=undefined;
        this.form.categoryextdept='';
        this.categoryValue=[];
        this.taginputVisible = false;
        this.taginputValue = '';
        this.taginputVisiblePrint = false;
        this.taginputValuePrint = '';
        this.form.ticket='';
        this.overlinecredit=false;
        this.ticket=[];
        this.ticketprint=[];
        if (this.$refs.refattguid) {
          this.$refs.refattguid.reset();
        }
        if(this.idd.length==1)
          this.change1(this.idd[0]);
        this.Supplier.supplier = ''
        this.Supplier.login = ''
        this.Supplier.password = ''
        this.Supplier.loginv2 = ''
        this.Supplier.passwordv2 = ''
        this.Supplier.clientid = ''
        this.Supplier.clientsecret = ''
        this.Supplier.url = ''
        this.selectSupplier = ''
        this.serverAlertTitle = '';
        this.form.attguid = attUUID();
      },
      deleteaddress(index, row) {
        this.aform.splice(index, 1)
      },
      addAddress() {
        this.$refs.AddressData.initAddressData()
        this.OpenDialog1()
      },
      taghandleClose(tag) {
        this.ticket.splice(this.ticket.indexOf(tag), 1);
      },
      tagshowInput() {
        this.taginputVisible = true;
        this.$nextTick(_ => {
          this.$refs.saveTagInput.$refs.input.focus();
        });
      },
      taghandleInputConfirm() {
        let inputValue = this.taginputValue;
        if (inputValue) {
          this.ticket.push(inputValue);
        }
        this.taginputVisible = false;
        this.taginputValue = '';
      },
      taghandleClosePrint(tag) {
        this.ticketprint.splice(this.ticketprint.indexOf(tag), 1);
      },
      tagshowInputPrint() {
        this.taginputVisiblePrint = true;
        this.$nextTick(_ => {
          this.$refs.saveTagInputPrint.$refs.input.focus();
        });
      },
      taghandleInputConfirmPrint() {
        let inputValue = this.taginputValuePrint;
        if (inputValue) {
          this.ticketprint.push(inputValue);
        }
        this.taginputVisiblePrint = false;
        this.taginputValuePrint = '';
      },
      OpenDialog1() {
        this.$refs.AddressData.showaddress()
      },
      setBasisGoods(){
        this.$refs.SettingMenthodEdit1.initData(this.form.monthlybasis,this.CanEdit);
      },
      setHappendate(){
        this.$refs.AgeEdit.initData(this.form.customerserial,this.form.aging,this.CanEdit);
      },
      AfterBasis(monthlybasis) {
        this.form.monthlybasis = monthlybasis;
      },
      AfterAgeEdit(aging){
        this.form.aging = aging;
      },
      openAuthZoneDialog() {
        if (this.form.authzone) {
          try {
            this.authZoneItems = JSON.parse(this.form.authzone) || [];
          } catch (e) {
            this.authZoneItems = [];
          }
        } else {
          this.authZoneItems = [];
        }
        this.tempProvince = '';
        this.tempCity = '';
        this.tempCustomerSerial = '';
        this.tempCustomerName = '';
        this.authZoneSearch = '';
        this.authZoneDialogVisible = true;
      },
      showCustomerForAuthZone() {
        this.$refs.authzoneCustSel.show(1, '选择客户');
      },
      onTempCustomerSelect(customerserial, customername, row) {
        this.tempCustomerSerial = customerserial;
        this.tempCustomerName = customername;
        // 选择了客户，清除区域
        this.tempProvince = '';
        this.tempCity = '';
      },
      clearTempCustomer() {
        this.tempCustomerSerial = '';
        this.tempCustomerName = '';
      },
      onTempProvinceChange(data) {
        if (data.value == '省') data.value = '';
        this.tempProvince = data.value;
        // 选择了区域，清除客户
        this.tempCustomerSerial = '';
        this.tempCustomerName = '';
      },
      onTempCityChange(data) {
        if (data.value == '市') data.value = '';
        this.tempCity = data.value;
        // 选择了区域，清除客户
        this.tempCustomerSerial = '';
        this.tempCustomerName = '';
      },
      addAuthZoneItem() {
        var province = this.tempProvince;
        var city = this.tempCity;
        var custSerial = this.tempCustomerSerial;
        var custName = this.tempCustomerName;
        // 必须选一个维度
        if (!province && !custSerial) {
          this.$message({message: '请选择客户或省份', type: 'warning'});
          return;
        }
        if (custSerial) {
          // 客户维度：检查重复
          for (var i = 0; i < this.authZoneItems.length; i++) {
            if (this.authZoneItems[i].customerserial === custSerial) {
              this.$message({message: '该客户已存在授权', type: 'warning'});
              return;
            }
          }
          this.authZoneItems.push({customerserial: custSerial, customername: custName});
          this.tempCustomerSerial = '';
          this.tempCustomerName = '';
        } else {
          // 区域维度：检查重复（同区域不能重复，全省/下属城市互斥）
          for (var i = 0; i < this.authZoneItems.length; i++) {
            var item = this.authZoneItems[i];
            if (!item.customerserial) {
              if (item.province === province && item.city === city) {
                this.$message({message: '该区域已存在', type: 'warning'});
                return;
              }
              if (!city && item.province === province && item.city) {
                this.$message({message: '已设置"' + province + '"的下属城市，不能重复设置', type: 'warning'});
                return;
              }
              if (city && item.province === province && !item.city) {
                this.$message({message: '已设置"' + province + '"全境，不能重复设置下属城市', type: 'warning'});
                return;
              }
            }
          }
          this.authZoneItems.push({province: province, city: city});
          this.tempProvince = '';
          this.tempCity = '';
        }
      },
      deleteAuthZoneItem(index) {
        this.authZoneItems.splice(index, 1);
      },
      saveAuthZoneDialog() {
        this.form.authzone = JSON.stringify(this.authZoneItems);
        this.authZoneDialogVisible = false;
      },
    },
    watch: {
      unitgroup(val) {
        if (val instanceof Array) {
          this.form.unitgroup = val.join(',')
          //this.isShow  供应商 3 免运费、直发
          //this.isdeliverShow 客户 2 配送服务
          this.isShow = this.form.unitgroup.indexOf(3) > -1;
          this.isdeliverShow = this.form.unitgroup.indexOf(1) > -1;
        }
      },
      settingmenthod(val) {
        this.form.settingmenthod = val.join(',')
      }
    },
    mounted() {
      this.aform = [];
      this.acontactor = [];
      getControlData().then(response => {
        this.controlData = response.data.obj
      });
      independentDept().then(response => {
        for (var i = 0; i < response.data.obj.length; i++) {
          this.idd.push(response.data.obj[i])
        }
        if (this.idd.length == 1)
          this.change1(this.idd[0]);
      })
      this.userInfoModel = JSON.parse(localStorage.getItem("hpapi_userInfoModel"))
      this.showEssilor = false;
      if (this.userInfoModel.mobile == '15250395939' || this.userInfoModel.mobile == '15050885921') {
        this.showEssilor = true;
      }
    },
    components: {
      AddressEdit,
      AgeEdit,
      ExternaldeptcontactorEdit,
      ExternaldeptSel,
      AccountAgeEdit,
      SaleContractList,
      SettingMenthodEdit,
      SaleFavourList
    }
  }
</script>


<style scoped>
  .query-table td {
    border: 1px solid #E0DFDF;
    vertical-align: center;
    height: 40px;
    line-height: 40px;
    padding: 2px;
  }

  .query-table td.content {
    text-align: center;
  }

  .query-table td.mainlink {
    font-weight: bold;
  }

  .titlecolor {
    color: #20A0FF;
    width: 100%;
  }

  .serverAlertCss {
    line-height: 18px;
  }
</style>



// WEBPACK FOOTER //
// src/components/set/externaldept/ExternaldeptEdit.vue